import { FaHome, FaUserCog } from "react-icons/fa";

export const userLinks = [
	{ label: "Inicio", path: "/inicio", icon: FaHome },
	{ label: "Perfil", path: "/perfil", icon: FaUserCog },
];